import React, { useEffect, useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import MolGrid from "../../components/Grid/MolGrid";
import Buttons from "../../components/ui/button/Buttons";
import { xeroPaymentFormData } from "./data/XeroPaymentUpdateForm.data";
import { XeroPaymentUpdateListConfig } from "./data/XeroPaymentUpdateListConfig";
import { useGetAllPaidInvoicesMutation, useGetXeroPaymentUpdateTaskListMutation, useUpdateMembershipDetailsAfterPaymentMadeMutation } from "../../app/services/XeroPayment/xeroPaymentApi";
import moment from "moment";
import ToastService from "../../services/toastService/ToastService";
import { APIUrl } from "../../utils/API/fetchBaseQuery";

const XeroPaymentUpdate = () => {
  const xeroPaymentRef = useRef();
  const molGridRef = useRef();
  const [xeroPaymentForm, setXeroPaymentForm] = useState(xeroPaymentFormData);
  const [dataSource, setDataSource] = useState([])
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
    SearchText: null,
    totalCount: 0,
    PaymentStatus: null,
  });
  const [showPageLoader, setShowPageLoader] = useState(false);
  const [loaderText, setLoaderText] = useState("");

  const [getCompanyList, { isSuccess, isLoading, data: xeroPaymentListResponse }] = useGetXeroPaymentUpdateTaskListMutation();
  const [updateMembershipDetailsAfterPaymentMade, { isSuccess: updateMembershipDetailsSuccess, isLoading: updateMembershipDetailsLoading, data: updateMembershipDetailsResponse }] = useUpdateMembershipDetailsAfterPaymentMadeMutation();
  const [getAllPaidInvoices, { isSuccess: paidInvoicesSuccess, isLoading: paidInvoicesLoading, data: getAllPaidInvoicesData }] = useGetAllPaidInvoicesMutation();

  useEffect(() => {
    getCompanyList(paginationRequest);
  }, [])

  useEffect(() => {
    if (!updateMembershipDetailsLoading && updateMembershipDetailsSuccess && updateMembershipDetailsResponse) {
      setShowPageLoader(false);
      ToastService.success("Application sent successfully.")
      getCompanyList(paginationRequest);
    }
  }, [updateMembershipDetailsLoading, updateMembershipDetailsSuccess, updateMembershipDetailsResponse]);

  useEffect(() => {
    if (!updateMembershipDetailsLoading && updateMembershipDetailsSuccess) {
      setShowPageLoader(false);
    }
  }, [updateMembershipDetailsLoading, updateMembershipDetailsSuccess]);

  useEffect(() => {
    if (!isLoading && isSuccess && xeroPaymentListResponse) {
      let xeroRecord = xeroPaymentListResponse.itemList.map((item) => {
        return {
          ...item,
          isDisable: item.status === "Pending" || false,
          date: item.paymentDate == null ? "-" : moment(item.paymentDate).format('DD MMM YYYY'),
          invoiceLink: `${APIUrl}/Common/getPDF?type=CorporateMembershipPaymentInvoice&fileName=${item?.invoicePath}`,
          totalAmount: item.totalAmount > 0 ? `$${(item?.totalAmount ?? 0).toLocaleString("en-SG", { minimumFractionDigits: 2, maximumFractionDigits: 2, })}` : '-',
          // ${(item?.totalAmount ?? 0).toLocaleString("en-SG", { minimumFractionDigits: 2, maximumFractionDigits: 2, })}
        }
      })
      setPaginationRequest(prev => ({ ...prev, totalCount: xeroPaymentListResponse.totalCount }));
      setDataSource(xeroRecord);
    }
  }, [isLoading, isSuccess, xeroPaymentListResponse]);

  useEffect(() => {
    if (!paidInvoicesLoading && paidInvoicesSuccess && getAllPaidInvoicesData) {
      if (getAllPaidInvoicesData[0]?.memberId > 0) {
        ToastService.success("Updated xero invoice.")
        getCompanyList(paginationRequest);
      } else {
        ToastService.warning("No PAID invoices found in Xero.")
      }
    }
  }, [paidInvoicesLoading, paidInvoicesSuccess, getAllPaidInvoicesData]);

  const handleSendClick = (rowData) => {
    setLoaderText("Your application is being processed. Please wait...");
    setShowPageLoader(true);
    const request = {
      SgbcCorporateMemberId: rowData?.corporateMemberId,
      InvoiceNo: rowData.invoiceNumber,
      IsRenewal: rowData?.isRenewal
    }
    updateMembershipDetailsAfterPaymentMade(request);
  }

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize };
    setPaginationRequest(updatedPaginationRequest);
    getCompanyList(updatedPaginationRequest);
  };

  const handleSearch = () => {
    if (!xeroPaymentRef.current) {
      return;
    }
    const formData = xeroPaymentRef?.current?.getFormData();
    const updatedPaginationRequest = {
      pageNo: 1,
      pageSize: 20,
      SearchText: formData?.companyName || null,
      PaymentStatus: formData?.paymentStatus?.label || null,
    };
    setPaginationRequest(updatedPaginationRequest);
    getCompanyList(updatedPaginationRequest);
  };

  const handleUpdate = () => {
    getAllPaidInvoices()
  }

  const handleClear = () => {
    const updatedFormData = { ...xeroPaymentFormData };
    updatedFormData.initialState = {
      companyName: null,
      paymentStatus: null,
    };
    setXeroPaymentForm(updatedFormData);

    const request = {
      ...paginationRequest,
      SearchText: null,
      PaymentStatus: null,
      totalCount: 0,
    };
    setPaginationRequest((prev) => ({ ...prev, ...request }));
    getCompanyList(request);
  }

  const actionHandler = {
    // SEND: handleSendClick,
    ["SEND EMAIL"]: handleSendClick,
  };

  return (
    <>
      {showPageLoader && (
        <div className="processing-modal-overlay">
          <div className="processing-modal">
            <div className="spinner"></div>
            <p>{loaderText}</p>
          </div>
        </div>
      )}

      <div className="xero-payment-update">
        <div className="payment-update-filter row payment-update-filter-new">
          <div className="status-input">
            <FormCreator ref={xeroPaymentRef} {...xeroPaymentForm} />
          </div>
          <div className="xero-right-side-btn mt-0 mb-3 ">
            <div className="d-flex gap-2">

              <Buttons
                buttonText="Search"
                buttonTypeClassName="success-btn  mb-2"
                onClick={handleSearch}
              />
              <Buttons
                buttonText="Clear"
                buttonTypeClassName="black-btn  mb-2"
                onClick={handleClear}
              />
            </div>
          </div>
        </div>
        <Buttons
          buttonText="Update"
          buttonTypeClassName="xero-updatebtn btn-right"
          onClick={handleUpdate}
          isLoading={paidInvoicesLoading}
          isDisable={paidInvoicesLoading}
        />
        <div className="payment-update-list xero-payment-grid">
          <MolGrid
            ref={molGridRef}
            configuration={XeroPaymentUpdateListConfig}
            allowPagination={true}
            dataSource={dataSource}
            isLoading={isLoading}
            pagination={paginationRequest}
            onPageChange={handlePageChange}
            onActionChange={actionHandler}
          />
        </div>
      </div>
    </>
  );
};
export default XeroPaymentUpdate;
